import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileUtilsService {
  fileDownload(blob: Blob, fileName: string): void {
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = objectUrl;
    if (fileName) {
      a.download = fileName;
    }
    a.target = '_blank';
    a.click();
  }
}
